import { useHealth } from '../api/health';

/**
 * Dev-build only: a fixed strip across the top when the local API is
 * running against the production database (`npm run dev:prod[-rw]`), so
 * real customer data is never mistaken for test data. Never rendered in a
 * production build.
 */
export function DevDatabaseBanner() {
  if (!import.meta.env.DEV) return null;
  return <DevDatabaseBannerInner />;
}

function DevDatabaseBannerInner() {
  const health = useHealth();
  const target = health.data?.dbTarget;
  if (!target) return null;
  const readWrite = target === 'production-rw';
  return (
    <div
      role="alert"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        padding: '6px 16px',
        textAlign: 'center',
        fontSize: 'var(--font-size-sm)',
        fontWeight: 600,
        color: '#fff',
        background: readWrite ? '#b91c1c' : '#b45309',
      }}
    >
      {readWrite
        ? 'LOCAL → PRODUCTION DATABASE (READ-WRITE): every save changes live customer data.'
        : 'Local → production database (read-only): browsing real data; changes are blocked.'}
    </div>
  );
}
